import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const liveBpContextName = 'live_context';
export const liveBpContextSchemaVersion = 5;
export type LiveBpContext = Fields<typeof liveBpContextName, typeof liveBpContextSchemaVersion>;

const defaults = createNullObject([
  'audience_type',
  'encoder_type',
  'event_privacy',
  'is_guest_speaker',
  'lead_source',
  'live_event_id',
  'live_feature',
  'live_production_method',
  'live_status',
  'recurring_live_event_id',
]);

export const buildLiveBpContext = (
  fields: PartialWithRequired<LiveBpContext, 'live_event_id' | 'live_event_type'>,
) => {
  return {
    live_context: new EventContext(liveBpContextName, liveBpContextSchemaVersion, {
      ...defaults,
      ...fields,
    }),
  };
};
